module.exports = __webpack_public_path__ + "media/application/images/icons/positive-trend-a4a94a7b3a86aa99c8b5a40504d7369d.svg";